
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "../../assets/css/EnquiryReport.css"; // Adjust the path according to your project structure

function EnquiryReport() {
  const { id } = useParams();
  const [filtered, setFiltered] = useState([]);
  const [courses, setCourses] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [source, setSource] = useState([]);

  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState("");

  const [Selectedsource, setSelectedsource] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [branch, setbranch] = useState([])
  const [Branches, setselectBranch] = useState([])
  const [loading, setLoading] = useState(false)

  const [available_staff, setavailable_staff] = useState([]);

  const [selected_staff, setselected_staff] = useState([]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const leadsResponse = await axios.get(apiUrl + "/leads");
        setFiltered(leadsResponse.data);

        const coursesResponse = await axios.get(apiUrl + "/course");
        setCourses(coursesResponse.data);


        const branchresponse = await axios.get(apiUrl + "/branch");

        console.log("Branch response:", branchresponse.data);


        if (Array.isArray(branchresponse.data)) {
          setbranch(branchresponse.data);
        } else {
          console.error("Unexpected data format:", branchresponse.data);
        }




        const uniqueStatuses = Array.from(
          new Set(leadsResponse.data.map((item) => item.followups_status))
        ).map((status) => ({ followups_status: status }));

        setStatuses(uniqueStatuses);




        const uniqueSource = Array.from(
          new Set(leadsResponse.data.map((item) => item.Source_type))
        ).map((status) => ({ Source_type: status }));

        setSource(uniqueSource);

        // =============== code to filter the unique staff data ====================
        const staff_data = leadsResponse.data.filter((item) => item.assign_staff != null)
        // console.log("the staff data in the fetch data is : ",staff_data);

        //  setavailable_staff(staff_data);

        const new_staff_data = staff_data.reduce((acc, item) => {
          if (!acc.some((obj) => obj.assign_staff.empid === item.assign_staff.empid)) {
            acc.push(item);
          }
          return acc;
        }, []);

        setavailable_staff(new_staff_data);
        // =============== code to filter the unique staff data ====================

        // console.log("The new_staff_data is : ",new_staff_data);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formatDatefitching = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  const filteredData = filtered.filter((item) => {
    const isCourseMatch = selectedCourse
      ? item.Prefered_course === selectedCourse
      : true;

    const isBranchMatch = Branches
      ? item.branch_id?.branch_name === Branches
      : true;



    const isStatusMatch = selectedStatus
      ? item.followups_status === selectedStatus
      : true;

    const issourcematch = Selectedsource
      ? item.Source_type === Selectedsource
      : true;


    const itemEnquiryDate = new Date(item.Enquiry_date);
    const isFromDateMatch = fromDate
      ? itemEnquiryDate >= new Date(fromDate)
      : true;
    const isToDateMatch = toDate ? itemEnquiryDate <= new Date(toDate) : true;

    // const isSearchMatch = searchTerm
    //   ? item.student_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     String(item.mobile_no).includes(searchTerm)
    //   : true;

    // code to filter the staff
    const isStaffMatch = selected_staff && item.assign_staff != null
      ? item.assign_staff && item.assign_staff.empid === selected_staff
      : true;

    const isSearchMatch = searchTerm
      ? item.student_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.student_name.toUpperCase().includes(searchTerm.toUpperCase()) ||
      String(item.mobile_no)
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      String(item.mobile_no)
        .toUpperCase()
        .includes(searchTerm.toUpperCase()) ||

      item.Prefered_course.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.branch_id?.branch_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||

      item.assign_staff?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||

      item.Prefered_course.toUpperCase().includes(searchTerm.toUpperCase()) ||
      item.Source_type.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.Source_type.toUpperCase().includes(searchTerm.toUpperCase()) ||
      item.followups_status
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      item.followups_status.toUpperCase().includes(searchTerm.toUpperCase())
      : true;

    return (
      isCourseMatch &&
      isStatusMatch &&
      isBranchMatch &&
      issourcematch &&
      isFromDateMatch &&
      isToDateMatch &&
      isSearchMatch &&
      isStaffMatch
    );
  });

  const currentEntries = filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );

  const handleEntriesPerPageChange = (event) => {
    setEntriesPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
    setCurrentPage(1);
  };


  const handleSourcetype = (event) => {
    setSelectedsource(event.target.value);
    setCurrentPage(1);
  };



  const handleBranchChange = (event) => {
    setselectBranch(event.target.value);
    setCurrentPage(1);

    // console.log("The selected value in the handleBranchChange is : ",event.target.value);

    let staff_data = filtered.filter((item) => item.assign_staff != null)

    if (event.target.value == "") {
      const new_staff_data = staff_data.reduce((acc, item) => {
        if (!acc.some((obj) => obj.assign_staff.empid === item.assign_staff.empid)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setavailable_staff(new_staff_data);
    }
    else {
      staff_data = staff_data.filter((item) => item.branch_id.branch_name == event.target.value);

      const new_staff_data = staff_data.reduce((acc, item) => {
        if (!acc.some((obj) => obj.assign_staff.empid === item.assign_staff.empid)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setavailable_staff(new_staff_data);
    }

  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
    setCurrentPage(1);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  // =========== code to fetch the data at initially ================
  useEffect(() => {
    handleClearFilters();
  }, []);
  // =========== code to fetch the data at initially ================


  const handleClearFilters = () => {
    setSelectedCourse("");
    setSelectedStatus("");
    setselectBranch("");
    setFromDate("");
    setSelectedsource("");
    setToDate("");
    setSearchTerm("");
    setCurrentPage(1);
    setselected_staff("");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handleCopy = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const tableData = tableElement.innerText;
      navigator.clipboard
        .writeText(tableData)
        .then(() => {
          alert("Table data copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };

  const handleCSVExport = () => {
    const csvHeaders = [
      "S.No",
      "Name",
      "Mobile No",
      "Course",
      "Source Type",
      "Enquiry Date",
      "Status",
    ];
    const csvData = filteredData.map((item, index) => [
      index + 1,
      item.student_name,
      item.mobile_no,
      item.Prefered_course,
      item.Source_type,
      formatDate(item.Enquiry_date),
      item.followups_status,
    ]);

    const csvContent = [
      csvHeaders.join(","), // Headers
      ...csvData.map((row) => row.join(",")), // Data rows
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "Enquiry report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const worksheet = XLSX.utils.table_to_sheet(tableElement);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "Enquiry_Report.xlsx");
    } else {
      console.error(
        "Table with ID 'tableId' not found. Check if the table is rendered in the DOM."
      );
    }
  };

  // const handleGeneratePDF = () => {
  //   const tableElement = document.getElementById("tableId");
  //   if (!tableElement) {
  //     console.error("Table with ID 'tableId' not found");
  //     return;
  //   }
  //   html2canvas(tableElement)
  //     .then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");
  //       const pdf = new jsPDF();
  //       pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
  //       pdf.save("Enquiry_report.pdf");
  //     })
  //     .catch((error) => {
  //       console.error("Error generating PDF: ", error);
  //     });
  // };


  // const handleGeneratePDF = () => {
  //   const tableElement = document.getElementById("tableId");
  //   if (!tableElement) {
  //     console.error("Table with ID 'tableId' not found");
  //     return;
  //   }

  //   // Use html2canvas to capture the table content as an image
  //   html2canvas(tableElement, { scale: 2 }) // Increase scale for better quality
  //     .then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");
  //       const pdf = new jsPDF();

  //       // Define PDF page width and height
  //       const pageWidth = pdf.internal.pageSize.width;
  //       const pageHeight = pdf.internal.pageSize.height;

  //       // Set initial position for the image
  //       let positionY = 10;

  //       // Check if the table image fits within one page
  //       if (canvas.height > pageHeight) {
  //         const imgHeight = (canvas.height * pageWidth) / canvas.width;
  //         const pagesRequired = Math.ceil(imgHeight / pageHeight);

  //         // Add the first page with the full image
  //         pdf.addImage(imgData, "PNG", 10, positionY, pageWidth - 20, imgHeight);

  //         // If the content is too long, we need to add more pages
  //         for (let i = 1; i < pagesRequired; i++) {
  //           pdf.addPage();  // Add a new page
  //           pdf.addImage(imgData, "PNG", 10, positionY, pageWidth - 20, imgHeight);
  //         }
  //       } else {
  //         // If it fits within one page, just add it normally
  //         pdf.addImage(imgData, "PNG", 10, positionY, pageWidth - 20, canvas.height);
  //       }

  //       pdf.save("Enquiry_Report.pdf");
  //     })
  //     .catch((error) => {
  //       console.error("Error generating PDF: ", error);
  //     });
  // };


  // const handleGeneratePDF = () => {
  //   const tableElement = document.getElementById("tableId");
  //   if (!tableElement) {
  //     console.error("Table with ID 'tableId' not found");
  //     return;
  //   }
  
  //   html2canvas(tableElement, { scale: 2 }).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF();
  
  //     const pageWidth = pdf.internal.pageSize.width;
  //     const pageHeight = pdf.internal.pageSize.height;
  //     const imgWidth = pageWidth - 20; // Set width to fit within PDF
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
  

  //     pdf.setFontSize(18);
  //     pdf.setFont("helvetica", "bold");
  //     pdf.text("Enquiry Report", pageWidth / 2, 6, { align: "center" });

  //     let positionY = 10;
  //     let remainingHeight = imgHeight;
  //     let sourceY = 0;
  
  //     while (remainingHeight > 0) {
  //       const cropHeight = Math.min(pageHeight - 20, remainingHeight);
  
  //       const pageCanvas = document.createElement("canvas");
  //       pageCanvas.width = canvas.width;
  //       pageCanvas.height = cropHeight * (canvas.width / imgWidth);
  //       const pageCtx = pageCanvas.getContext("2d");
  
  //       pageCtx.drawImage(
  //         canvas,
  //         0, sourceY, canvas.width, pageCanvas.height, // Source (Crop) from Original Canvas
  //         0, 0, pageCanvas.width, pageCanvas.height // Destination (New Canvas)
  //       );
  
  //       const croppedImg = pageCanvas.toDataURL("image/png");
  //       pdf.addImage(croppedImg, "PNG", 10, positionY, imgWidth, cropHeight);
  
  //       remainingHeight -= cropHeight;
  //       sourceY += pageCanvas.height;
  
  //       if (remainingHeight > 0) {
  //         pdf.addPage();
  //       }
  //     }
  
  //     pdf.save("Enquiry_Report.pdf");
  //   }).catch((error) => {
  //     console.error("Error generating PDF: ", error);
  //   });
  // };

  
  const handleGeneratePDF = () => {
    const tableElement = document.getElementById("tableId");
    if (!tableElement) {
      console.error("Table with ID 'tableId' not found");
      return;
    }
  
    html2canvas(tableElement, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.95); // High-quality JPEG
      const pdf = new jsPDF();
  
      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;
      const imgWidth = pageWidth - 20;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
      // Calculate file size
      const byteCharacters = atob(imgData.split(",")[1]); // Decode Base64
      const fileSizeKB = Math.round(byteCharacters.length / 1024);
      console.log(`Estimated PDF file size: ${fileSizeKB} KB`);
  
      pdf.setFontSize(18);
      pdf.setFont("helvetica", "bold");
      pdf.text("Enquiry Report", pageWidth / 2, 15, { align: "center" });
  
      let positionY = 25;
  
      if (imgHeight <= pageHeight - 30) {
        pdf.addImage(imgData, "JPEG", 10, positionY, imgWidth, imgHeight);
      } else {
        let remainingHeight = imgHeight;
        let sourceY = 0;
        let pageNumber = 1;
  
        while (remainingHeight > 0) {
          // Calculate the height of the current portion
          const cropHeight = Math.min(pageHeight - 40, remainingHeight);
          const pageCanvas = document.createElement("canvas");
          pageCanvas.width = canvas.width;
          pageCanvas.height = Math.floor(cropHeight * (canvas.width / imgWidth));
          const pageCtx = pageCanvas.getContext("2d");
  
          // ✅ Fix: Ensure proper cropping and avoid cutting off table rows improperly
          pageCtx.drawImage(
            canvas,
            0, sourceY, canvas.width, pageCanvas.height, // Source (original image)
            0, 0, pageCanvas.width, pageCanvas.height // Destination (cropped image)
          );
  
          const croppedImg = pageCanvas.toDataURL("image/jpeg", 0.95);
          pdf.addImage(croppedImg, "JPEG", 10, positionY, imgWidth, cropHeight);
  
          remainingHeight -= cropHeight;
          sourceY += pageCanvas.height;
  
          if (remainingHeight > 0) {
            pdf.addPage();
            pageNumber++;
            positionY = 10;
  
            // ✅ Add page number on each new page
            pdf.setFontSize(12);
            pdf.text(`Page ${pageNumber}`, pageWidth - 20, pageHeight - 10);
          }
        }
      }
  
      pdf.save("Enquiry_Report.pdf");
    }).catch((error) => {
      console.error("Error generating PDF: ", error);
    });
  };
  


  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Table</title>
            <style>
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #000; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h1>Enquiry Report</h1>
            <div>${tableElement.outerHTML}</div>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };

  useEffect(() => {
    gettoken();
    getprevillages();
  }, []);


  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      if (id) { }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);
    const total_previlages = username.modules;
    const new_enquiry = total_previlages.find((item) => item.name == "Enquiry Report")
    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions)
  }






  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };


  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  const createPagination = () => {
    let liTag = [];
    let beforePage = currentPage - 1;
    let afterPage = currentPage + 1;
    let active;

    if (currentPage > 1) {
      liTag.push(
        <li className="page-item" key="prev">
          <button
            className="page-link"
            onClick={() => paginate(currentPage - 1)}
          >
            <FaAngleLeft /> Prev
          </button>
        </li>
      );
    }

    if (currentPage > 2) {
      liTag.push(
        <li className="page-item" key="first" onClick={() => paginate(1)}>
          <button className="page-link">1</button>
        </li>
      );
      if (currentPage > 3) {
        liTag.push(
          <li className="page-item disabled" key="dots1">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    if (currentPage === totalPages) {
      beforePage -= 2;
    } else if (currentPage === totalPages - 1) {
      beforePage -= 1;
    }

    if (currentPage === 1) {
      afterPage += 2;
    } else if (currentPage === 2) {
      afterPage += 1;
    }

    for (let plength = beforePage; plength <= afterPage; plength++) {
      if (plength > totalPages || plength <= 0) continue;
      active = currentPage === plength ? "active" : "";
      liTag.push(
        <li
          className={`page-item ${active}`}
          key={plength}
          onClick={() => paginate(plength)}
        >
          <button className="page-link">{plength}</button>
        </li>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        liTag.push(
          <li className="page-item disabled" key="dots2">
            <span className="page-link">...</span>
          </li>
        );
      }
      liTag.push(
        <li
          className="page-item"
          key="last"
          onClick={() => paginate(totalPages)}
        >
          <button className="page-link">{totalPages}</button>
        </li>
      );
    }

    if (currentPage < totalPages) {
      liTag.push(
        <li className="page-item" key="next">
          <button
            className="page-link"
            onClick={() => paginate(currentPage + 1)}
          >
            Next <FaAngleRight />
          </button>
        </li>
      );
    }

    return liTag;
  };



  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}

      <div className="container-fluid">
        <div
          className="card p-2"
          style={{
            marginTop: "-80px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
        >
          <div className="row">
            <h6 style={{color:"#8f0505"}}>
              <b>Enquiry Report</b>
            </h6>

          </div>
          <hr />
          <div className="row p-2">
            <div className="col-lg-2 col-md-3 col-sm-12 mx-3">
              <input
                type="date"
                value={fromDate}
                onChange={handleFromDateChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12">
              <input
                type="date"
                value={toDate}
                onChange={handleToDateChange}
                className="form-control"
              />
            </div>

            {/* branch */}
            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={Branches} // Ensure this matches the state variable for the selected branch
                // onChange={(e) => setselectBranch(e.target.value)} // Update the state
                onChange={handleBranchChange}
                className="form-control"
              >
                <option value="">All Branches</option>
                {branch.map((branchItem) => (
                  <option key={branchItem._id} value={branchItem.branch_id?.branch_name}>
                    {branchItem.branch_name}
                  </option>
                ))}
              </select>
            </div>



            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={selectedCourse}
                onChange={handleCourseChange}
                className="form-control"
              >
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.id} value={course.course_name}>
                    {course.course_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={selectedStatus}
                onChange={handleStatusChange}
                className="form-control"
              >
                <option value="">Select Status</option>
                {statuses.map((status, index) => (
                  <option key={index} value={status.followups_status}>
                    {status.followups_status}
                  </option>
                ))}
              </select>
            </div>






            {/* <div className="col-lg-2 col-md-3 col-sm-12">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
              className="form-control"
            />
          </div> */}
            <div className="col-lg-1 col-md-2 col-sm-12">
              <button className="btn btn-danger" onClick={handleClearFilters}>
                Clear
              </button>
            </div>

            <div className="col-lg-2 col-md-3 col-sm-12" style={{ marginTop: '10px', marginLeft: '15px' }}>
              <select
                value={selected_staff}
                // onChange={handleStatusChange}
                onChange={(e) => setselected_staff(e.target.value)}
                className="form-control"
              >
                <option value="">All Staffs</option>
                {available_staff.map((staff, index) => (
                  <option key={index} value={staff.assign_staff.empid}>
                    {staff.assign_staff.name}
                  </option>
                ))}
              </select>
              {/* <p>{selected_staff}</p> */}
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12" style={{ marginTop: '10px', marginLeft: '15px' }}>
              <select
                value={Selectedsource}
                onChange={handleSourcetype}
                className="form-control"
              >
                <option value="">Select Source</option>
                {source.map((status, index) => (
                  <option key={index} value={status.Source_type}>
                    {status.Source_type}
                  </option>
                ))}
              </select>
            </div>




          </div>
          <hr />
          <div className="row">
            <div className="col-md-3 d-flex align-items-center">
              <p className="mb-0 mr-2">Show: </p>
              <select
                value={entriesPerPage}
                onChange={handleEntriesPerPageChange}
                className="form-control mx-2"
                style={{ width: "50px" }}
              >
                {/* <option value={5}>5</option> */}
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={filteredData.length}>All</option>
              </select>
            </div>

            <div className="col-md-6">
              {previllages.download && (
                <button className="btn btn-secondary2 mx-2" onClick={handleCopy}>
                  Copy
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-success2 mx-2" onClick={handleCSVExport}>
                  CSV
                </button>
              )}

              {previllages.download && (
                <button className="btn btn-excel2 mx-2" onClick={handleExport}>
                  Excel
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-info2 mx-2" onClick={handleGeneratePDF}>
                  PDF
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-warning2 mx-2" onClick={handlePrint}>
                  Print
                </button>
              )}
            </div>

            <div className="col-md-3 d-flex align-items-center">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                className="form-control"
              />
            </div>
          </div>
          <table id="tableId" className="table table-striped table-bordered mt-2">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Name</th>
                <th>Mobile No</th>
                <th>Course</th>
                <th>Source Type</th>
                <th>Enquiry Date</th>
                <th>Staff Name</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {currentEntries.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1 + (currentPage - 1) * entriesPerPage}</td>
                  <td>{item.branch_id?.branch_name}</td>
                  <td>{item.student_name}</td>
                  <td>{item.mobile_no}</td>
                  <td>{item.Prefered_course}</td>
                  <td>{item.Source_type}</td>
                  <td>{formatDate(item.Enquiry_date)}</td>
                  <td>{item.assign_staff ? item.assign_staff.name : ""}</td>
                  <td>{item.followups_status}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* <nav>
          <ul className="pagination justify-content-center">
            {Array.from({ length: totalPages }, (_, i) => (
              <li
                key={i}
                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(i + 1)}
                >
                  {i + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav> */}
          <div className="row">
            <div className="mt-3 pb-5">
              <div className="row">
                <div className="col-lg-7 col-sm-12 mt-1">
                  <span className="text-dark">
                    Page {currentPage} of {totalPages}
                  </span>
                </div>
                <div className="col-lg-5">
                  <nav>
                    <ul className="pagination justify-content-center">
                      {createPagination()}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EnquiryReport;

